import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/view/index/index'

Vue.use(Router);
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};
export default new Router({
  base: '/',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/view/login/Login.vue')
    },
    {
      path: '/index/:tid',
      name: 'index',
      component: Main
    },
    {
      path: '/monitor',
      name: 'monitor',
      component: Main,
      children: [
        {
          path: 'monitor',
          name: 'monitor',
          component: () => import('@/view/monitor/monitor')
        }
      ]
    },
    {
      path: '/management',
      name: 'management',
      component: Main,
      children: [
        {
          path: 'account',
          name: 'account',
          component: () => import('@/view/management/account/account')
        },
        {
          path: 'orgMembers',
          name: 'OrgMembers',
          component: () => import('@/view/management/account/OrgMembers')
        },
        {
          path: 'standardItem',
          name: 'standardItem',
          component: () => import('@/view/management/standardItem/standardItem')
        },
        {
          path: 'debugRecord',
          name: 'debugRecord',
          component: () => import('@/view/management/debugRecord/debugRecord')
        },
        {
          path: 'commission/detail',
          name: 'commissionDetail',
          component: () => import('@/view/management/debugRecord/detail')
        },
        {
          path: 'authority',
          name: 'authority',
          component: () => import('@/view/management/authority/Authority')
        },
        {
          path: 'panelFunction',
          name: 'Feature',
          component: () => import('@/view/management/panelFunction/Feature')
        },
        {
          path: 'archive',
          name: 'archive',
          component: () => import('@/view/management/archive/archive')
        },
        {
          path: 'product',
          name: 'product',
          component: () => import('@/view/management/product/product')
        }
      ]
    },
    {
      path: '/system',
      name: 'system',
      component: Main,
      children: [
        {
          path: 'unitTest',
          name: 'unitTest',
          component: () => import('@/view/system/unitTest/unitTest')
        },
        {
          path: 'password',
          name: 'password',
          component: () => import('@/view/system/password/password')
        },
        {
          path: 'operationMode',
          name: 'operationMode',
          component: () => import('@/view/system/operationMode/operationMode')
        },
        {
          path: 'cleaningTreatment',
          name: 'cleaningTreatment',
          component: () => import('@/view/system/cleaningTreatment/cleaningTreatment')
        },
        {
          path: 'networkController',
          name: 'networkController',
          component: () => import('@/view/system/networkController/networkController')
        },
        {
          path: 'language',
          name: 'language',
          component: () => import('@/view/system/language/language')
        }
      ]
    },
    {
      path: '/install',
      name: 'install',
      component: Main,
      children: [
        {
          path: 'registrationOfComponent',
          name: 'registrationOfComponent',
          component: () => import('@/view/install/registrationOfComponent/registrationOfComponent')
        },
        {
          path: 'analogAlarm',
          name: 'analogAlarm',
          component: () => import('@/view/install/analogAlarm/analogAlarm')
        },
        {
          path: 'fixedPointAddressing',
          name: 'fixedPointAddressing',
          component: () => import('@/view/install/fixedPointAddressing/fixedPointAddressing')
        },
        {
          path: 'remoteUpgrade',
          name: 'remoteUpgrade',
          component: () => import('@/view/install/remoteUpgrade/remoteUpgrade')
        }
      ]
    },
    {
      path: '/setting',
      name: 'setting',
      component: Main,
      children: [
        {
          path: 'printer',
          name: 'printer',
          component: () => import('@/view/setting/printer/printer')
        },
        {
          path: 'manualStartStop',
          name: 'manualStartStop',
          component: () => import('@/view/setting/manualStartStop/manualStartStop')
        },
        {
          path: 'componentShielding',
          name: 'componentShielding',
          component: () => import('@/view/setting/componentShielding/componentShielding')
        }
      ]
    },
    {
      path: '/test',
      name: 'test',
      component: Main,
      children: [
        {
          path: 'simulationCurve',
          name: 'simulationCurve',
          component: () => import('@/view/test/simulationCurve/simulationCurve')
        },
        {
          path: 'statusBrowsing',
          name: 'statusBrowsing',
          component: () => import('@/view/test/statusBrowsing/statusBrowsing')
        },
        {
          path: 'dataQuery',
          name: 'dataQuery',
          component: () => import('@/view/test/dataQuery/dataQuery')
        },
        {
          path: 'statusSignalValue',
          name: 'statusSignalValue',
          component: () => import('@/view/test/statusSignalValue/statusSignalValue')
        },
        {
          path: 'typeStatus',
          name: 'typeStatus',
          component: () => import('@/view/test/typeStatus/typeStatus')
        },
        {
          path: 'authorization',
          name: 'authorization',
          component: () => import('@/view/test/authorization/authorization')
        },
        {
          path: 'operatingVoltage',
          name: 'operatingVoltage',
          component: () => import('@/view/test/operatingVoltage/operatingVoltage')
        }
      ]
    },
    {
      path: '/query',
      name: 'query',
      component: Main,
      children: [
        {
          path: 'registeredAddress',
          name: 'registeredAddress',
          component: () => import('@/view/query/registeredAddress/registeredAddress')
        },
        {
          path: 'linkageProgramming',
          name: 'linkageProgramming',
          component: () => import('@/view/query/linkageProgramming/linkageProgramming')
        },
        {
          path: 'historyRecord',
          name: 'historyRecord',
          component: () => import('@/view/query/historyRecord/historyRecord')
        },
        {
          path: 'unitBoardInformation',
          name: 'unitBoardInformation',
          component: () => import('@/view/query/unitBoardInformation/unitBoardInformation')
        },
        {
          path: 'annotationInformation',
          name: 'annotationInformation',
          component: () => import('@/view/query/annotationInformation/annotationInformation')
        },
        {
          path: 'unitConfiguration',
          name: 'unitConfiguration',
          component: () => import('@/view/query/unitConfiguration/unitConfiguration')
        },
        {
          path: 'networkConfiguration',
          name: 'networkConfiguration',
          component: () => import('@/view/query/networkConfiguration/networkConfiguration')
        },
        {
          path: 'authorizationManagement',
          name: 'authorizationManagement',
          component: () => import('@/view/query/authorizationManagement/authorizationManagement')
        }
      ]
    }
  ]
})
